import { ComplexValue } from 'app/types-shared';

export const getBreadcrumbs = (hierarchy: ComplexValue<number>[], value: number): number[] => {

  if ((hierarchy?.length ?? 0) === 0) {
    return [];
  }

  for (const branch of hierarchy) {
    if (branch.value === value) {
      return [branch.value];
    }

    const branchBreadcrumbs = getBreadcrumbs(branch.descendants, value);

    if (branchBreadcrumbs.length > 0) {
      return [branch.value, ...branchBreadcrumbs];
    }
  }

  return [];
};

export const getBreadcrumbsFromPath = (hierarchy: ComplexValue<number>[], path: number[], value: number): number[] => {

  if ((hierarchy?.length ?? 0) === 0 || (path?.length ?? 0) === 0) {
    return [];
  }

  if (hierarchy.some(item => item.value === value)) {
    return [value];
  }

  const branch = hierarchy.find(item => item.value === path[0]);

  if (!branch) {
    return [];
  }

  const branchBreadcrumbs = getBreadcrumbsFromPath(branch.descendants, path.slice(1), value);

  return branchBreadcrumbs.length
    ? [branch.value, ...branchBreadcrumbs]
    : [];
};
